export default __webpack_public_path__ + "static/mtec-story-0512fa6f7cec7c3ecdd83c354137295b.pdf";